<template>
   <div class="scence">
    <div class="content">
      <div class="tabs">
        <div class="country" v-for="(item,index) in cusMulSelectData" :key="index">
            <span @click="setListCheck(index, item.value)" :class="[ choosed === index ? 'countryon' : '' ]">{{item.label}}</span>
        </div>
      </div>
      <!-- <cusMulSelect :name="name" :data="cusMulSelectData" :selectData.sync="selectData"></cusMulSelect> -->
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">站名:</span>
          <div class="selcountry">
          <el-input
            placeholder="请输入站名"
            v-model="query.stnm"
            @keyup.enter.native="onLoadData"
            class="filter-item"
            style="width: 150px;"
            clearable
             @change="Global.emptyQuery(query.stnm,onLoadData)"
          ></el-input>
          </div>
          <span class="search" @click="onLoadData">查询</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="tableList" :data="waterdata" v-loading="loading" :max-height="height" border  highlight-current-row style="width: 100%"
            @sort-change="changeTableSort">
              <el-table-column type="index"  width="60" align="center" label="序号"></el-table-column>
              <el-table-column align="center"  label="站名" prop="stnm" v-if="query.sttp === 'RR'"></el-table-column>
              <el-table-column align="center"  label="站名" prop="stationName" v-if="query.sttp === 'ZZ'"></el-table-column>
              <el-table-column align="center"  label="所属地区" prop="stlc" v-if="query.sttp === 'RR'" >
                <template slot-scope="scope">
                  <span>{{ !scope.row.stlc ? '-' : scope.row.stlc }}</span>
                </template>
              </el-table-column>
              <el-table-column  v-if="query.sttp === 'RR'" label="汛限水位" prop="floodLimit" min-width="70" align="center" :sortable="'custom'" >
                <template slot-scope="scope">
                  <span>{{ !scope.row.floodLimit ? '-' : scope.row.floodLimit[0].fsltdz }}</span>
                </template>
              </el-table-column>
              <!-- 整合河道防洪指标 -->
                <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="左堤高程@(m)" :render-header="renderheader" prop="zdgc"  :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.zdgc ? '-' : scope.row.zdgc }}</span>
                </template>
              </el-table-column>
                <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="右堤高程@(m)" :render-header="renderheader" prop="ydgc"  :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.ydgc ? '-' : scope.row.ydgc }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="警戒水位@(m)" :render-header="renderheader" prop="jjsw"  :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.jjsw ? '-' : scope.row.jjsw }}</span>
                </template>
              </el-table-column>
                <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="警戒流量@(m3/s)" :render-header="renderheader" prop="jjll"  min-width="120" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.jjll ? '-' : scope.row.jjll }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="保证水位@(m)" :render-header="renderheader" prop="bzsw"  :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.bzsw ? '-' : scope.row.bzsw }}</span>
                </template>
              </el-table-column>
               <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="保证流量@(m3/s)" :render-header="renderheader" prop="bzll" min-width="120" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.bzll ? '-' : scope.row.bzll }}</span>
                </template>
              </el-table-column>
                <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="平滩流量@(m3/s)"  :render-header="renderheader" prop="ptll" min-width="120" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.ptll ? '-' : scope.row.ptll }}</span>
                </template>
              </el-table-column>
               <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="高水位告警值"  prop="gswgjz" min-width="120" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.gswgjz ? '-' : scope.row.gswgjz }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="大流量告警值"  prop="dllgjz" min-width="120" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.dllgjz ? '-' : scope.row.dllgjz }}</span>
                </template>
              </el-table-column>
               <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="枯警水位"   prop="kjsw" min-width="100" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.kjsw ? '-' : scope.row.kjsw }}</span>
                </template>
              </el-table-column>
               <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="枯警流量"  prop="kjll" min-width="100" :sortable="'custom'">
                <template slot-scope="scope">
                  <span>{{ !scope.row.kjll ? '-' : scope.row.kjll }}</span>
                </template>
              </el-table-column>
               <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="启动预报水位标准"  prop="ybswbz"  :sortable="'custom'" min-width="150">
                <template slot-scope="scope">
                  <span>{{ !scope.row.ybswbz ? '-' : scope.row.ybswbz }}</span>
                </template>
              </el-table-column>
               <el-table-column v-if="query.sttp === 'ZZ'" align="center" label="启动预报流量标准"  prop="ybllbz"  :sortable="'custom'" min-width="150">
                <template slot-scope="scope">
                  <span>{{ !scope.row.ybllbz ? '-' : scope.row.ybllbz }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" min-width="150" label="操作" v-if="query.sttp === 'ZZ'" >
                <template slot-scope="scope" >
                    <span class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span>
                </template>
              </el-table-column>
              <!-- 整合河道防洪指标 -->
              <el-table-column align="center" min-width="50" label="操作" v-if="query.sttp === 'RR'" >
                <template slot-scope="scope" >
                  <!-- <div class="operation"> -->
                    <!-- <span v-if="allowsPerm.update" class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span> -->
                    <span class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span>
                  <!-- </div> -->
                </template>
              </el-table-column>
            </el-table>
            </div>
          </div>
      </div>
    </div>
    <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="abow_dialog" >
      <el-form ref="userForm" :rules="rules" :model="form" label-width="90px">
        <el-form-item label="站名:" required  v-if="query.sttp === 'RR' ">
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stnm"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="站名:" required  v-if="query.sttp === 'ZZ' ">
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stationName"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="所属乡镇:" required v-if="query.sttp === 'RR' ">
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stlc"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="测站编码:" required v-if="query.sttp === 'ZZ' ">
          <el-form-item prop="stcd">
            <el-input :disabled="true" v-model="form.stationstcd"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="警戒水位:" required v-if="query.sttp === 'ZZ' ">
          <el-form-item prop="jjsw">
            <el-input v-model="form.jjsw" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="保证水位:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="bzsw">
            <el-input v-model="form.bzsw" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="左堤高程(m):" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="zdgc">
            <el-input v-model="form.zdgc" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="右堤高程(m):" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="ydgc">
            <el-input v-model="form.ydgc" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="警戒流量(m3/s):" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="jjll">
            <el-input v-model="form.jjll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="保证流量(m3/s):" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="bzll">
            <el-input v-model="form.bzll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="平滩流量(m3/s):" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="ptll">
            <el-input v-model="form.ptll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="高水位告警值:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="gswgjz">
            <el-input v-model="form.gswgjz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="大流量告警值:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="dllgjz">
            <el-input v-model="form.dllgjz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="枯警水位:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="kjsw">
            <el-input v-model="form.kjsw" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="枯警流量:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="kjll">
            <el-input v-model="form.kjll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="启动预报水位标准:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="ybswbz">
            <el-input v-model="form.ybswbz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="启动预报流量标准:" v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="ybllbz">
            <el-input v-model="form.ybllbz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
      <el-button @click ="onAdd(form.id)" type="primary" icon="el-icon-circle-plus" class="add-time" v-if="query.sttp === 'RR'">时段</el-button>
      <!-- 添加新增数据中的时间以下 -->
        <el-form ref='singleForm'
          class="time-floodlimit" v-for="(item,index) in singleData.floodLimit" :key="index" :model="item" label-width="90px">
         <el-form-item  label="时间分段:" required v-if="query.sttp  === 'RR'">
          <div class="time-block">
            <el-date-picker v-model="item.bgmd" required type="date" placeholder="开始日期" format=" MM-dd " value-format="MMdd">
            </el-date-picker>
            <div class="symbol">&nbsp;-&nbsp;</div>
           <el-date-picker v-model="item.edmd" required type="date" placeholder="结束日期" format=" MM-dd " value-format="MMdd">
           </el-date-picker>
          </div>
          </el-form-item>
        <el-form-item label="汛限水位:" required v-if="query.sttp  === 'RR'" >
          <el-form-item prop="floodLimit" id="floodLimit">
            <el-input v-model="item.fsltdz" required auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <div class="delete-icon">
          <i class="el-icon-delete" @click="onDelete(item, index)" style="cursor:pointer"></i>
         </div>
        </el-form>
         <!-- 添加新增数据中的时间以上 -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userTypes from '@/store/types/user'
// import cusMulSelect from '@/components/CusMulSelect.vue'
export default {
  // components: { cusMulSelect },
  data () {
    return {
      stid: '',
      stcd: '',
      singleData: {},
      name: '类型:',
      cusMulSelectData: [
        { label: '河道', value: 'ZZ' },
        { label: '水库', value: 'RR' }
      ],
      choosed: 0,
      selectData: '',
      loading: false,
      diagShow: false,
      diagTitle: '编辑',
      isActive: false, // 为水库时添加弹框类样式
      height: 200,
      form: {},
      query: {
        searchName: '',
        stnm: '',
        sid: '22',
        pageIndex: 1,
        pageSize: 500,
        sttp: 'ZZ'
      },
      waterdata: [],
      rules: {
        // ensure: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { required: true, message: '请输入数字' }
        // ],
        vigilance: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        floodLimit: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        jjsw: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ]
        // jjll: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // bzsw: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // bzll: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // ptll: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // gswgjz: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // dllgjz: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // kjsw: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // kjll: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // ybswbz: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // ybllbz: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // zdgc: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ],
        // ydgc: [
        //   { validator: this.Global.checkNumeral, trigger: 'blur' },
        //   { message: '请输入数字' }
        // ]
      }
    }
  },
  watch: {
    'selectData': function (newVal) {
      if (newVal === 'ZZ') {
        this.query.sttp = 'ZZ'
      } else if (newVal === 'RR') {
        this.query.sttp = 'RR'
      }
      this.onLoadData()
    }
  },
  methods: {
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    // 选择指定列进行排序
    changeTableSort (column) {
      // 获取字段名称和排序类型
      var fieldName = column.prop
      var sortingType = column.order
      // 汛限水位-按照降序排序
      if (fieldName === 'floodLimit') {
        if (sortingType === 'descending') {
          // this.waterdata = this.waterdata.map(item => { return item.floodLimit === undefined ? -1 : item.floodLimit }).sort((a, b) => b[fieldName][0].fsltdz - a[fieldName][0].fsltdz)
          this.waterdata = this.waterdata.sort((a, b) => b[fieldName] === undefined ? -1 : b[fieldName][0].fsltdz - a[fieldName][0].fsltdz)
        } else { // 升序
          // this.waterdata = this.waterdata.map(item => { return item.floodLimit === undefined ? { ...item, floodLimit: -1 } : item }).sort((a, b) => a[fieldName][0].fsltdz - b[fieldName][0].fsltdz)
          this.waterdata = this.waterdata.sort((a, b) => a[fieldName] === undefined ? -1 : a[fieldName][0].fsltdz - b[fieldName][0].fsltdz)
        }
      } else {
        if (sortingType === 'descending') {
          // this.waterdata = this.waterdata.map(item => { return item.ensure === undefined ? -1 : item.ensure }).sort((a, b) => b[fieldName] - a[fieldName])
          this.waterdata = this.waterdata.sort((a, b) => b[fieldName] === undefined ? -1 : b[fieldName] - a[fieldName])
        } else { // 升序
          // this.waterdata = this.waterdata.map(item => { return item.ensure === undefined ? { ...item, ensure: -1 } : item }).sort((a, b) => a[fieldName] - b[fieldName])
          this.waterdata = this.waterdata.sort((a, b) => a[fieldName] === undefined ? -1 : a[fieldName] - b[fieldName])
        }
      }
    },
    setListCheck (index, value) {
      this.choosed = index
      this.selectData = value
      this.$refs.tableList.clearSort()
    },
    onLoadData () {
      this.loading = true
      this.query.stationName = this.query.stnm
      if (this.query.sttp === 'ZZ') { // 河道
        this.$store.dispatch(userTypes.GET_RIVER_LIST_INFO, this.query).then(data => {
          this.waterdata = data.rows
          this.loading = false
        })
      } else { // 水库
        this.$store.dispatch(userTypes.STATION_WARN_WATER_INFO, this.query).then(data => {
          this.waterdata = data.rows
          this.loading = false
        })
      }
    },
    onEdit (row) {
      if (this.query.sttp === 'ZZ') {
        this.diagTitle = '河道水位测站编辑'
      } else {
        this.diagTitle = '水库水位测站编辑'
      }
      this.form = {}
      if (this.query.sttp === 'RR') {
        this.$store.dispatch(userTypes.BACK_STATION_WARN_WATER_INFO, { sid: '22', stid: row.id, pageIndex: 1, pageSize: 500 }).then(data => {
          this.singleData = Object.assign({ floodLimit: [] }, data.rows[0]) // 当水库floodlimit为空时
          this.stcd = this.singleData.stcd
        })
      }
      this.stid = row.id
      this.form = row
      this.form = Object.assign({}, this.form) // 取消时
      this.Global.clearValidate(this, 'userForm')
      this.diagShow = true
    },
    onSave () {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.query.sttp === 'RR') { // 水库水位保存
            let callbackVal = this.singleData.floodLimit.every(element => { // 新增时段，起始时间为空不执行
              return element.bgmd !== '' || element.enmd !== ''
            })
            if (callbackVal) {
              this.$store.dispatch(userTypes.BATCH_SAVE_STATION_WARN_WATER_INFO, { stid: this.stid, list: this.singleData.floodLimit }).then(() => {
                this.$notify.success({ title: '成功', message: '编辑成功.' })
                this.diagShow = false
                this.onLoadData()
                this.loading = false
              })
            } else {
              this.$notify.error({ title: '保存失败', message: '起始时间不能为空' })
              this.loading = false
            }
          } else { // 河道保存
            let user = Object.assign({}, this.form)
            this.$store.dispatch(userTypes.SAVE_RIVER_LIST_INFO, user).then(() => {
              this.$notify.success({ title: '成功', message: '编辑成功.' })
              this.diagShow = false
              this.onLoadData()
              this.loading = false
            })
          }
        }
      })
    },
    // 添加时间段设置
    onAdd (key) {
      this.singleData.floodLimit.push({
        id: '',
        stid: this.stid,
        stcd: this.stcd,
        fsltdz: '', // 汛限水位
        bgmd: '',
        enmd: ''
      })
    },
    // 删除对应时间段
    onDelete (item, i) {
      var index = this.singleData.floodLimit.indexOf(item)
      if (index !== -1) {
        this.singleData.floodLimit.splice(index, 1)
      }
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.onLoadData()
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['skt'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.scence /deep/ .el-dialog__body {
  overflow: hidden !important;
}
/deep/ .el-form{
  width: 100% !important;
}
/deep/.el-form-item {
  width: 50% !important;
  float: left;
}
/deep/ .el-form-item__label{
  width: 130px !important;
}
.skt{
  height: calc(100% - 80px) !important;
}
.tabs{
  margin-bottom: 10px;
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  .country{
    float: left;
    font-family: Microsoft YaHei UI;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    margin-left: 0.5%;
    cursor: pointer;
    .countryon, .categoryon{
      border-radius: 15px;
      background-color: #fda72c;
      color: #ffffff
    }
    span{
      padding: 4px 15px;
    }
  }
}
.note {
  color: #aaa;
  margin-left: 50px;
}
.app-container{
  width: 100%;
  height: 880px;
  position: relative;
  top: -80px;
  .filter-container {
    width: 100%;
    height: 80px;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  .el-table{
    background: #ffffff;
    border-radius: 5px;
  }
}
.operation{
  margin: 0 auto !important;
  width: 6.25rem;
  height: 100%;
}
// 水位时间设置增加样式
.add-time{
  position: absolute;
  // left: 25rem;
  top: 2.61rem;
  right: 1rem;
}
.time-block {
  display:flex;
  /deep/ .el-date-picker{
    margin-right: 10px;
    margin-left: 20px;
  }
  .symbol {
    margin-left:5px;
    margin-right:5px
  }
  /deep/ .el-date-editor.el-input {
    width: 150px !important;
  }
}
.time-floodlimit{
  height: 1.5rem;
}
.time-floodlimit  #floodLimit {
 width: 50% !important;
}
.time-floodlimit .el-icon-delete{
  position: relative;
  left: 25rem;
  bottom: 1.5rem;
}
.edit {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-56%);
  background: red;
  height:37px !important;
  width: 80px !important;
}
</style>
